<template>
 <div dir="rtl" class="d-flex align-items-center justify-content-center">
   <div class="card shadow p-3 col-lg-9 d-flex flex-column align-items-center justify-content-center" style="margin-top: 10vw;">
     <div class="d-flex justify-content-between w-100">
       <p class="fw-bold">⚠️خطا</p>
       <img src="../assets/img/android-chrome-192x192.png"   style="height: 2vw; width: 2vw;" alt="">

     </div>
     <h1><span>4</span><span style="font-size: 7vw;" class="text-info anime">0</span><span>3</span></h1>
     <p> دسترسی غیرمجاز!</p>
     <router-link to="/pishkhan" class="btn btn-submit-1 btn-primary">برو به پیشخوان</router-link>
   </div>
 </div>
</template>
<script >
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  methods:{
    logout() {
      this.$store.commit('logout')
      this.$cookies.remove('image_profile')
      router.push('/')
      toast.info('به دلیل دسترسی غیرمجاز از سیستم خارج شدید!')
    },
  },
  mounted() {
    this.logout()
  }
}
</script>



<style scoped>
p{
  font-size: 1vw;
}



</style>